const NAV_SUBGROUPS = {
  digitize: [
    { text: 'Digitize Overview', isLink: true, pageKey: 'digitize' },
    { text: 'Tape Transfer', isLink: false, subKey: 'tape_transfer' },
    { text: 'Photo Scanning', isLink: false, subKey: 'photo_scan' },
    { text: 'Film Digitizing', isLink: false, subKey: 'film_transfer' },
    { text: 'Disc Transfer', isLink: true, pageKey: 'digitalTransfer' },
    { text: 'Audio Conversion', isLink: true, pageKey: 'audioTransfer' },
  ],
  enhance: [
    { text: 'Photo Restoration', isLink: true, pageKey: 'photoRestoration' },
    { text: 'Photo Colorization', isLink: true, pageKey: 'photoColorization' },
    { text: 'Photo Retouching', isLink: true, pageKey: 'photoRetouching' },
  ],
  create: [
    { text: 'Wall Art', isLink: true, pageKey: 'photoArt' },
    { text: 'Story Art', isLink: true, pageKey: 'storyArt' },
    { text: 'Forever Books', isLink: true, pageKey: 'foreverBooks' },
    { text: 'Cine-Montages', isLink: true, pageKey: 'cineMontages' },
    { text: 'Gift Card', isLink: true, pageKey: 'giftCard' },
  ],
  digitize_fl: [
    { text: 'Local Digitizing Page', isLink: true, pageKey: 'southFloridaDigitize' },
    { text: 'Tape Transfer', isLink: true, pageKey: 'localTapeTransfer' },
    { text: 'Photo Scanning', isLink: true, pageKey: 'localPhotoScanning' },
    { text: 'Film Digitizing', isLink: true, pageKey: 'localFilmTransfer' },
    { text: 'Disc Transfer', isLink: true, pageKey: 'localDigitalTransfer' },
    { text: 'Audio Conversion', isLink: true, pageKey: 'localAudioTransfer' },
  ],
  services: [
    { text: 'Business Services', isLink: true, pageKey: 'businessServices' },
    { text: 'Genealogy', isLink: true, pageKey: 'preservation' },
    { text: 'Forever Cloud', isLink: true, pageKey: 'foreverCloud' },
    { text: 'Forever Care', isLink: true, pageKey: 'faq' },
  ],
  info: [
    { text: 'Contact', isLink: true, pageKey: 'contact' },
    { text: 'How It Works', isLink: true, pageKey: 'howItWorks' },
    { text: 'Our Story', isLink: true, pageKey: 'ourStory' },
    { text: 'Our Team', isLink: true, pageKey: 'ourMission' },
    { text: 'Reviews', isLink: true, pageKey: 'reviews' },
    { text: 'Gift Guide', isLink: true, pageKey: 'giftGuide' },
  ],
};

export default NAV_SUBGROUPS;
